import React from 'react'

import AccessView from './AccessView'
import GrantAccess from './GrantAccess'

import useStyles from './styles'

type PortalAccessProps = {
  user: LocalUser
  canEdit: boolean
}

const PortalAccess: React.FC<PortalAccessProps> = ({ user, canEdit }) => {
  const hasAccess = React.useMemo(() => Boolean(user.auth), [user])

  const classes = useStyles()

  return (
    <div className={classes.root}>
      {hasAccess ? (
        <AccessView user={user} canEdit={canEdit} />
      ) : (
        <GrantAccess user={user} canEdit={canEdit} />
      )}
    </div>
  )
}

export default PortalAccess
